import { render, staticRenderFns } from "./PaymentSingleBankTransfer.vue?vue&type=template&id=1745def4"
import script from "./PaymentSingleBankTransfer.vue?vue&type=script&lang=js"
export * from "./PaymentSingleBankTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports